import { FundOutlined, HomeOutlined, NodeIndexOutlined, ReconciliationOutlined, WalletOutlined, TagOutlined, AppstoreAddOutlined, ImportOutlined } from '@ant-design/icons';
 
import PERMISSIONS_FULFILLMENT_PAGE from './permissions/fulfillmentPage';
import PERMISSIONS_AGGREGATOR_PAGE from './permissions/aggregatorPage';
import PERMISSIONS_WALLET_PAGE from './permissions/walletPage';
import PERMISSIONS_REPORT_PAGE from './permissions/reportPage';
import PERMISSIONS_PRODUCT_GROUP_PAGE from './permissions/productGroupPage';
import PERMISSIONS_PRODUCT_MANAGEMENT_PAGE from './permissions/productManagementPage';
import PERMISSIONS_VOUCHER_PIN_IMPORT_PAGE from './permissions/voucherPinImportPage';

import type { MenuGroup } from '../components/layout/types';

import { ROUTER } from './router';

export const menuConfig: MenuGroup[] = [
  {
    titleKey: 'Overview',
    items: [
      {
        key: 'dashboard',
        labelKey: 'sidebar.dashboard',
        link: ROUTER.DASHBOARD(),
        icon: <HomeOutlined />,
        // children: [
        //   {
        //     key: 'vouchers',
        //     labelKey: 'sidebar.vouchers',
        //     link: ROUTER.VOUCHERS(),
        //     icon: <TagsOutlined />,
        //   },
        // ],
      },
    ],
  },
  {
    titleKey: 'Fulfillment',
    items: [
      {
        key: 'fulfillment',
        labelKey: 'sidebar.fulfillment',
        link: ROUTER.FULFILLMENT(),
        icon: <ReconciliationOutlined />,
        requiredPermissions: [PERMISSIONS_FULFILLMENT_PAGE.VIEW],
      },
      {
        key: 'aggregator',
        labelKey: 'sidebar.aggregator',
        link: ROUTER.AGGREGATOR(),
        icon: <NodeIndexOutlined />,
        requiredPermissions: [PERMISSIONS_AGGREGATOR_PAGE.VIEW],
      },
      {
        key: 'wallet',
        labelKey: 'sidebar.wallet',
        link: ROUTER.WALLET(),
        icon: <WalletOutlined />,
        requiredPermissions: [PERMISSIONS_WALLET_PAGE.VIEW],
      },
      {
        key: 'report',
        labelKey: 'sidebar.report',
        link: ROUTER.REPORT(),
        icon: <FundOutlined />,
        requiredPermissions: [PERMISSIONS_REPORT_PAGE.VIEW],
      },
    ],
  },
  {
    titleKey: 'Products',
    items: [
      {
        key: 'product-group',
        labelKey: 'sidebar.product_group',
        link: ROUTER.PRODUCT_GROUP(),
        icon: <TagOutlined />,
        requiredPermissions: [PERMISSIONS_PRODUCT_GROUP_PAGE.VIEW],
      },
      {
        key: 'product-management',
        labelKey: 'sidebar.product_management',
        link: ROUTER.PRODUCT_MANAGEMENT(),
        icon: <AppstoreAddOutlined />,
        requiredPermissions: [PERMISSIONS_PRODUCT_MANAGEMENT_PAGE.VIEW],
      },
    ],
  },
  {
    titleKey: 'VoucherPin',
    items: [
      {
        key: 'voucher-pin-import',
        labelKey: 'sidebar.voucher_pin_import',
        link: ROUTER.VOUCHER_PIN_IMPORT(),
        icon: <ImportOutlined />,
        requiredPermissions: [PERMISSIONS_VOUCHER_PIN_IMPORT_PAGE.VIEW],
      },
    ],
  },
];
